module.exports = __webpack_public_path__ + "static/social-proof-4-5a928f57abb910e66f734b94d3c949f0.jpg";